module.exports = __webpack_public_path__ + "img/img45.b491858b.jpg";